import Vue from 'vue'
import Vuex from 'vuex'
import {
  fetchData
} from '../axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    caller: {},
    messages: {},
    msisdn: '',
    email: '',
    sharedIdUrl: '',
    sharedId: '',
    isEligible: null,
    rafContentList: {},
    notEligibleUserMessages: [],
    pageLoaded: false,
    locale: 'gr',
    error: false,
    errorMessage: '',
    termsUrl: '',
  },
  getters: {
    getCaller: state => {
      return state.caller
    },
    getMessages: state => {
      return state.messages
    },
    getMsisdn: state => {
      return state.msisdn
    },
    getEmail: state => {
      return state.email
    },
    getShareIdUrl: state => {
      return state.sharedIdUrl
    },
    getShareId: state => {
      return state.sharedId
    },
    getIsEligible: state => {
      return state.isEligible
    },
    getRafContentList: state => {
      return state.rafContentList
    },
    getNotEligibleUserMessages: state => {
      return state.notEligibleUserMessages
    },
    getPageLoaded: state => {
      return state.pageLoaded
    },
    getLocale: state => {
      return state.locale
    },
    getError: state => {
      return state.error
    },
    getErrorMessage: state => {
      return state.errorMessage
    },
    getTermsUrl: state => {
      return state.termsUrl
    }
  },
  mutations: {
    setCaller (state, caller) {
      state.caller = caller
    },
    setMessages (state, messages) {
      state.messages = messages
    },
    setMsisdn (state, msisdn) {
      state.msisdn = msisdn
    },
    setEmail (state, email) {
      state.email = email
    },
    setShareIdUrl (state, sharedIdUrl) {
      state.sharedIdUrl = sharedIdUrl
    },
    setShareId (state, sharedId) {
      state.sharedId = sharedId
    },
    setIsEligible (state, isEligible) {
      state.isEligible = isEligible
    },
    setRafContentList (state, rafContentList) {
      state.rafContentList = rafContentList
    },
    setNotEligibleUserMessages (state, notEligibleUserMessages) {
      state.notEligibleUserMessages = notEligibleUserMessages
    },
    setPageLoaded (state, pageLoaded) {
      state.pageLoaded = pageLoaded
    },
    setLocale (state, locale) {
      state.locale = locale
    },
    setError (state, error) {
      state.error = error
    },
    setErrorMessage (state, errorMessage) {
      state.errorMessage = errorMessage
    },
    setTermsUrl (state, termsUrl) {
      state.termsUrl = termsUrl
    }
  },
  actions: {
    constructCallerInfo ({
      commit
    }, locale) {
      const caller = {
        callingSystem: 'myQweb',
        salesCode: '',
        username: document.getElementById('user-info').getAttribute('data-username'),
        data: '',
        locale: locale,
        channel: 'Q'
      }
      commit('setCaller', caller)
    },
    loadMessages ({
      commit
    }, locale) {
      // const lang = locale === 'el_GR' ? 'gr' : 'en'

      fetchData(
        'get',
          // `/${lang}/vueContentService/referafriend/`
        `/sites/Satellite/?pagename=fetchVueTranslationsEntry&ciKey=referafriend&locale=${locale}`
      )
        .then(async function (response) {
          if (response.data) {
            commit('setMessages', response.data)
            const srg = {}
            srg[locale] = response.data
            sessionStorage.messages = JSON.stringify(srg)
          } else {
            // window.location.replace('/')
            console.log('error');
          }
        })
        .catch(function () {
          // console.log(err)
          // window.location.replace('/')
          console.log('error');
        })
    },
    createInvitation ({ commit, state }) {
      const inputObj = {}
      inputObj.caller = state.caller
      inputObj.msisdn = state.msisdn
      inputObj.email = state.email

      return new Promise((resolve, reject) => {
        fetchData(
          'post',
          '/apiv2/referafriend/createInvitation/',
          inputObj
        )
          .then(async function (response) {
            if (response.data.errorLevel === 0) {
              commit('setIsEligible', response.data.userEligible)
              if (response.data.userEligible) {
                commit('setShareIdUrl', response.data.sharedIdUrl)
                commit('setShareId', response.data.sharedId)
                commit('setRafContentList', response.data.content)
                commit('setTermsUrl', response.data.rafTcLink)
                // set timeout
                setTimeout(() => {
                  console.log('Pushing Data layer');
                  handleDataLayer.init();
                  handleDataLayer.pushRafDataLayer({
                    "event": {
                      "initiator": "referrer-dashboard",
                      "eligibleForRAF": true,
                      "segment": state.rafContentList.segmentId
                    }
                  })
                }, 1000)
              } else {
                commit('setNotEligibleUserMessages', response.data.notEligibleUserMessages)
                setTimeout(() => {
                  handleDataLayer.init();
                  console.log('Pushing Data layer');
                  handleDataLayer.pushRafDataLayer({
                    "event": {
                      "initiator": "referrer-not-eligible-page",
                      "eligibleForRAF": false
                    }
                  })
                }, 1000)
              }
              resolve()
            } else {
              commit('setError', true)
              commit('setErrorMessage', response.data.errorMessage)
              resolve()
              reject(new Error('An error has occurred.'))
            }
          })
          .catch(function (err) {
            if (err.response.status === 401) {
              let expires = ''
              const date = new Date()
              date.setTime(date.getTime() + (24 * 60 * 60 * 1000))
              expires = '; expires=' + date.toUTCString()
              document.cookie = 'prepaidDL' + '=' + (encodeURIComponent(window.location.href) || '') + expires + '; path=/'
              window.location.href = '/gr/myq/'
              reject(err)
            } else reject(err)
            reject(err)
          }).finally(() => {
            commit('setPageLoaded', true)
          })
      })
    },
    getShareIdInfo ({ state }) {
      const inputObj = {}
      inputObj.caller = state.caller

      return new Promise((resolve, reject) => {
        fetchData(
          'post',
          '/apiv2/referafriend/getShareIdInfo/',
          inputObj
        )
          .then(async function (response) {
            if (response.data.ErrorLevel === 0) {
              resolve()
            } else {
              resolve()
              reject(new Error('An error has occurred.'))
            }
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    getAcceptanceIdInfo ({ state }) {
      const inputObj = {}
      inputObj.caller = state.caller

      return new Promise((resolve, reject) => {
        fetchData(
          'post',
          '/apiv2/referafriend/getAcceptanceIdInfo/',
          inputObj
        )
          .then(async function (response) {
            if (response.data.ErrorLevel === 0) {
              resolve()
            } else {
              resolve()
              reject(new Error('An error has occurred.'))
            }
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    acceptInvitation ({ state }) {
      const inputObj = {}
      inputObj.caller = state.caller

      return new Promise((resolve, reject) => {
        fetchData(
          'post',
          '/apiv2/referafriend/acceptInvitation/',
          inputObj
        )
          .then(async function (response) {
            if (response.data.ErrorLevel === 0) {
              resolve()
            } else {
              resolve()
              reject(new Error('An error has occurred.'))
            }
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    finalizeInvitation ({ state }) {
      const inputObj = {}
      inputObj.caller = state.caller

      return new Promise((resolve, reject) => {
        fetchData(
          'post',
          '/apiv2/referafriend/finalizeInvitation/',
          inputObj
        )
          .then(async function (response) {
            if (response.data.ErrorLevel === 0) {
              resolve()
            } else {
              resolve()
              reject(new Error('An error has occurred.'))
            }
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    pokeReferrer ({ state }) {
      const inputObj = {}
      inputObj.caller = state.caller

      return new Promise((resolve, reject) => {
        fetchData(
          'post',
          '/apiv2/referafriend/pokeReferrer/',
          inputObj
        )
          .then(async function (response) {
            if (response.data.ErrorLevel === 0) {
              resolve()
            } else {
              resolve()
              reject(new Error('An error has occurred.'))
            }
          })
          .catch(function (err) {
            reject(err)
          })
      })
    },
    setLocale({ commit }, locale) {
      commit('setLocale', locale)
    }
  }
})
